import {TransactionColKey} from "../../../enums/TransactionColKey";
import {t} from "@lingui/macro";
import {ActionTdWidth, DateTimeWidth, DateWidth, NumberWidth, TypeWidth} from "../Common/CommonWidths";
import {amountProps, contactNameCellStyle} from "../Common/CommonColKeyInfo";
import { getTransactionCustomFieldColumns } from "./getTransactionCustomFieldColumns";

export function getTransactionColumn(transactionColKey = '', fields = {transaction: [], contact: []}) {
    // Custom Fields
    const fieldColMapper = {};
    const transactionFields = getTransactionCustomFieldColumns(fields);
    transactionFields.forEach(({key, title, width, ellipsis, ...restProps}) => {
        fieldColMapper[key] = {
            title,
            width,
            ellipsis,
            ...restProps,
        };
    });

    switch (transactionColKey) {
        case TransactionColKey.number:
            return {
                title: t`No.`,
                width: NumberWidth,
            };
        case TransactionColKey.number_with_link:
            return {
                title: t`No.`,
                width: 115,
            };
        case TransactionColKey.type:
            return {
                title: t`Type`,
                width: TypeWidth,
            };
        case TransactionColKey.all_types:
            return {
                title: t`Type`,
                width: 150,
            };
        case TransactionColKey.date:
            return {
                title: t`Date`,
                width: DateWidth,
            };
        case TransactionColKey.contact_name:
            return {
                title: t`Contact`,
                ...contactNameCellStyle,
            };
        case TransactionColKey.contact2_name:
            return {
                title: t`Contact 2`,
                ...contactNameCellStyle,
                dataIndex: 'contact2_name',
            };
        case TransactionColKey.billing_party:
            return {
                title: t`Billing Party`,
                width: 150,
                ellipsis: true,
            };
        case TransactionColKey.shipping_info:
            return {
                title: t`Shipping Info`,
                width: 150,
                ellipsis: true,
            };
        case TransactionColKey.shipping_party:
            return {
                title: t`Shipping Party`,
                width: 150,
                ellipsis: true,
            };
        case TransactionColKey.payment_account:
            return {
                title: t`Payment Account`,
                dataIndex: 'account_id',
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.deposit_to:
            return {
                title: t`Deposit To`,
                dataIndex: 'account_id',
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.pay_from:
            return {
                title: t`Pay From`,
                dataIndex: 'account_id',
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.transfer_from:
            return {
                title: t`Transfer From`,
                dataIndex: 'account_id',
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.transfer_to:
            return {
                title: t`Transfer To`,
                dataIndex: 'account2_id',
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.payment_method:
            return {
                title: t`Payment Method`,
                dataIndex: 'payment_method',
                width: 140,
                ellipsis: true,
            };
        case TransactionColKey.number2:
            return {
                title: t`Reference No.`,
                width: 120,
                ellipsis: true,
            };
        case TransactionColKey.title:
            return {
                title: t`Title`,
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.description:
            return {
                title: t`Description`,
                width: 160,
                ellipsis: true,
            };
        case TransactionColKey.amount:
            return {
                title: t`Amount`,
                ...amountProps,
            };
        case TransactionColKey.balance:
            return {
                title: t`Balance`,
                ...amountProps,
            };
        case TransactionColKey.overpayment:
            return {
                title: t`Overpayment`,
                dataIndex: 'balance',
                ...amountProps,
            };
        case TransactionColKey.tag_names:
            return {
                title: t`Tags`,
                width: 130,
                onCell: () => ({
                    onClick: event => {
                        event.stopPropagation(); // this will avoid onRow being called
                    },
                }),
            };
        case TransactionColKey.status:
            return {
                title: t`Status`,
                width: 80,
            };
        case TransactionColKey.invoice_number:
            return {
                title: t`Invoice No.`,
            };
        case TransactionColKey.invoice_description:
            return {
                title: t`Invoice Description`,
                ellipsis: true,
            };
        case TransactionColKey.invoice_status:
            return {
                title: t`Status`,
                width: 110,
            };
        case TransactionColKey.email:
            return {
                label: t`Email Tracker`,
                width: 35,
            };
        case TransactionColKey.transfer:
            return {
                label: t`Transfer Status`,
                width: 35,
            };
        case TransactionColKey.files:
            return {
                label: t`Attachments`,
                width: 35,
            };
        case TransactionColKey.custom_fields:
            return {
                title: t`Custom Fields`,
                width: 150,
                ellipsis: true,
            };
        case TransactionColKey.created_at:
            return {
                title: t`Created At`,
                width: DateTimeWidth,
            };
        case TransactionColKey.created_by:
            return {
                title: t`Created By`,
                ellipsis: true,
                width: 130,
            };
        case TransactionColKey.action:
            return {
                title: t`Action`,
                width: ActionTdWidth,
                onCell: () => ({
                    onClick: event => {
                        event.stopPropagation(); // this will avoid onRow being called
                    },
                }),
            };
        default: {
            if (fieldColMapper[transactionColKey])
                return fieldColMapper[transactionColKey];

            return {};
        }
    }
}
